const DropTypeSchemaOptions=()=>{
    return [{value:1,label:"Drop"},{value:2,label:"Air Drop"}]
    }
    export default DropTypeSchemaOptions;